"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _getEventTargetByTagName = _interopRequireDefault(require("../../utils/event/getEventTargetByTagName"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DataActionManager = /*#__PURE__*/function (_PureComponent) {
  function DataActionManager() {
    var _this;
    _classCallCheck(this, DataActionManager);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DataActionManager, [].concat(args));
    _defineProperty(_this, "onClick", function (evt) {
      var evtTarget = (0, _getEventTargetByTagName["default"])(evt, 'A');
      if (evtTarget) {
        var action = evtTarget.getAttribute('data-action');
        if (action) {
          evt.preventDefault();
          var href = evtTarget.href,
            target = evtTarget.target;
          var dataAction = _this.props.dataAction;
          dataAction(action, {
            url: href,
            target: target
          });
        }
      }
    });
    return _this;
  }
  _inherits(DataActionManager, _PureComponent);
  return _createClass(DataActionManager, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var props = {
        onClick: this.onClick
      };
      return /*#__PURE__*/(0, _react.cloneElement)(children, props);
    }
  }], [{
    key: "setDataAction",
    value: function setDataAction(action) {
      DataActionManager.defaultProps.dataAction = action;
    }
  }]);
}(_react.PureComponent);
_defineProperty(DataActionManager, "propTypes", {
  children: _propTypes["default"].node,
  dataAction: _propTypes["default"].func
});
_defineProperty(DataActionManager, "defaultProps", {
  children: '',
  dataAction: function dataAction(action, vars) {
    console.warn('%cJL-UI-KIT: Warning\n' + '  A link containing a data-action attribute has called props.dataAction("%s", %o)\n' + '  Use DataActionManager.setDataAction() to provide an action to handle this', 'color: red;', action, vars);
  }
});
var _default = exports["default"] = DataActionManager;